/** 区域初始车辆默认种子（Mongo 无 default 且无对应日期配置时使用） */

export const DEFAULT_AREA_IDS = [1, 2, 3, 4];

export function createSeedTemplateVehicles() {
  return { 1: 7, 2: 38, 3: 0, 4: 0 };
}

export function copyNumberKeyMap(map) {
  const result = {};
  Object.keys(map || {}).forEach((key) => {
    const n = Number(key);
    if (!Number.isNaN(n) && map[key] != null) {
      result[n] = map[key];
    }
  });
  return result;
}

export function toStringKeyMap(map) {
  const result = {};
  Object.keys(map || {}).forEach((key) => {
    if (map[key] != null) {
      result[String(key)] = map[key];
    }
  });
  return result;
}

export function mergeWithSeed(data) {
  const seed = createSeedTemplateVehicles();
  const src = copyNumberKeyMap(data);
  const merged = { ...seed };
  Object.keys(src).forEach((areaId) => {
    merged[areaId] = src[areaId];
  });
  return merged;
}

export const SOURCE_LABELS = {
  DATE: "日期独立配置",
  DEFAULT: "默认配置",
  SEED: "内置种子"
};
